import { useApp } from "../../provider";
import StackSizeNumber from "./containers/StackSizeNumber";
import { useInventory } from "./provider";
import { hasContainer } from "../ItemInspector";

export default function InventorySlots({
  rows = 4,
  cols = 9,
  bgImg = "",
  size = 54,
  className = "",
}) {
  const {
    type,
    inventory,
    draggedSlots,
    handleMouseOver,
    handleMouseDown,
    handleMouseUp,
  } = useInventory();

  const { items, handleMouseEnter, handleMouseLeave, readonly, setInspectedItem, setPreviewItem } = useApp();

  return (
    <div
      className={`relative grid ${className}`}
      style={{
        gridTemplateColumns: `repeat(${cols}, 1fr)`,
        gridTemplateRows: `repeat(${rows}, 1fr)`,
      }}
    >
      {inventory?.map((slot, slotIndex) => {
        const { id, count } = slot;
        const readable = id !== null ? items[id]?.readable : undefined;
        const inspect = (element) => {
          if (!readonly || id === null) return;
          if (hasContainer(slot)) {
            setPreviewItem(null);
            setInspectedItem(slot);
          } else {
            setPreviewItem({ item: slot, rect: element.getBoundingClientRect() });
          }
        };
        const handleClick = (e) => {
          if (e.button !== 0) return;
          e.stopPropagation();
          inspect(e.currentTarget);
        };

        return (
        <div
          key={`${type}-${slotIndex}`}
          className={`mc-grid type-${type} relative ${readonly && id !== null ? "mc-grid--inspectable" : ""} ${
            draggedSlots.includes(slotIndex) && id !== null && "opacity-50"
          }`} // position of class name mc-grid and type used for quick access. Don't change
          style={{
            width: `${size}px`,
            height: `${size}px`,
            padding: `${(size - 54) / 2}px`,
          }}
          title={!readonly && id !== null ? readable || slot.minecraftId || "物品" : undefined}
          role={readonly && id !== null ? "button" : undefined}
          tabIndex={readonly && id !== null ? 0 : undefined}
          aria-label={readonly && id !== null ? `${readable || slot.minecraftId || "物品"}，数量 ${count}，${hasContainer(slot) ? "点击打开容器" : "点击查看提示"}` : undefined}
          onClick={handleClick}
          onKeyDown={(e) => {
            if (readonly && (e.key === "Enter" || e.key === " ")) {
              e.preventDefault();
              inspect(e.currentTarget);
            }
          }}
          onContextMenu={(e) => readonly && id !== null && e.preventDefault()}
          onMouseOver={() => handleMouseOver(slotIndex)}
          onMouseDown={(e) => handleMouseDown(e, slotIndex)}
          onMouseUp={(e) => handleMouseUp(e, slotIndex)}
          onMouseEnter={(e) => {
            handleMouseEnter(slotIndex, type);
            if (readonly && id !== null && e.nativeEvent.pointerType !== "touch") {
              setPreviewItem({ item: slot, rect: e.currentTarget.getBoundingClientRect() });
            }
          }}
          onMouseLeave={() => {
            handleMouseLeave();
          }}
        >
          {id !== null && (
            <>
              <img
                src={items[id]?.texture}
                alt={items[id]?.readable}
                className="object-cover w-full h-full pixelated"
              />
              <StackSizeNumber
                count={count}
                style={{
                  margin: `${(size - 54) / 2}px`,
                }}
              />
            </>
          )}
        </div>
        );
      })}
    </div>
  );
}
